import React from 'react';

import { ICONS } from './AlertMessage.constants';
import { StyledAlertMessage } from './AlertMessage.styles';
import type { AlertStyleProps } from './AlertMessage.types';

type Props = AlertStyleProps & {
  children: React.ReactNode;
};

export const AlertMessage: React.FC<Props> = ({
  variant = 'success',
  children,
}) => {
  const Icon = ICONS[variant];

  return (
    <StyledAlertMessage variant={variant}>
      <Icon />
      <div>{children}</div>
    </StyledAlertMessage>
  );
};
